import { AbstractControl, ValidatorFn } from '@angular/forms';
import { getFilesFromControl } from './files-from-control.function';
import { getFileSize } from './get-file-size.function';

export function fileSizeTotalValidator(numberOfMegabytes: number): ValidatorFn {
	return (control: AbstractControl) => {
		const files = getFilesFromControl(control);

		if (!files) {
			return null;
		}

		return getFileSize(files.reduce((total, file) => total + file.size, 0)) > numberOfMegabytes
			? { fileSize: true }
			: null;
	};
}
